import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Notification } from '@Models';
import { AdminService } from '@Services';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-admin-notification',
  imports: [AsyncPipe],
  templateUrl: './admin-notification.component.html',
  styleUrl: './admin-notification.component.css',
})
export class AdminNotificationComponent implements OnInit {
  notifications$: Observable<Notification[]> | null = null;
  notifications: Notification[] = [];

  constructor(private _adminService: AdminService) {}

  ngOnInit() {
    this.loadNotifications();
  }

  loadNotifications() {
    this.notifications$ = this._adminService.getAllNotifications().pipe(
      tap((notifications) => {
        if (notifications) {
          this.notifications = notifications;
        }
      }),
    );
  }

  toggleNotification(i: number) {
    if (this.notifications[i]) {
      // Toggle the state immediately for responsive UI
      this.notifications[i].show = !this.notifications[i].show;

      // Send update to the server
      this.updateNotification(this.notifications[i]).subscribe();
    }
  }

  toggleDataStatus(i: number) {
    if (this.notifications[i]) {
      // Toggle the state immediately for responsive UI
      this.notifications[i].showDataStatus = !this.notifications[i].showDataStatus;

      // Send update to the server
      this.updateNotification(this.notifications[i]).subscribe();
    }
  }

  handleKeyEvent(event: KeyboardEvent, i: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleNotification(i);
    }
  }

  isDefaultType(type: string): boolean {
    return type.toLowerCase() === 'default';
  }

  updateNotification(notification: Notification) {
    const index = this.notifications.findIndex(
      (n) => n.type === notification.type && n.message === notification.message,
    );

    return this._adminService.updateNotification(notification).pipe(
      tap({
        next: (response: Notification) => {
          console.log('Notification updated successfully', response);
        },
        error: (error) => {
          console.error('Error updating notification', error);
          if (index !== -1 && this.notifications[index]) {
            this.notifications[index].show = !this.notifications[index].show;
          }
        },
      }),
    );
  }
}
